import { Component } from "react";
import { Link } from "react-router-dom";

// App-wide error boundary. Catches render-time exceptions from any child
// component, prevents the whole app from blank-white-screening, and gives
// the visitor a way forward. Wraps the router in App.js.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log to console for local dev; Sentry hook can be added here once
    // SENTRY_DSN is wired in Coolify (see PROJECT_LOG open items).
    if (typeof window !== "undefined" && window.console) {
      window.console.error("[ErrorBoundary]", error, info?.componentStack);
    }
  }

  handleReset = () => {
    this.setState({ hasError: false });
    if (typeof window !== "undefined") window.location.assign("/");
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-[#0A0B10] text-white flex items-center justify-center px-6">
        <div className="max-w-md text-center">
          <div className="text-[10px] uppercase tracking-widest text-white/40 font-mono">Unexpected error</div>
          <h1 className="font-display text-3xl mt-4 tracking-tight">Something broke on our end.</h1>
          <p className="mt-4 text-sm text-white/60 leading-relaxed">
            The page failed to render. Try again, or head back to the homepage.
          </p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <button
              onClick={this.handleReset}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full gradient-bg font-medium text-sm"
            >
              Reload homepage
            </button>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/15 hover:bg-white/5 text-sm"
            >
              Report the problem
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
